const typeAheadConstants = {
  GET_SEARCH_SUGGESTIONS_SUCCESS: "GET_SEARCH_SUGGESTIONS_SUCCESS",
  GET_SEARCH_SUGGESTIONS_FAILURE: "GET_SEARCH_SUGGESTIONS_FAILURE",
  SET_SELECTED_SUGGESTION: "SET_SELECTED_SUGGESTION",
  RESET_SEARCH_SUGGESTIONS: "RESET_SEARCH_SUGGESTIONS",
  SET_SEARCH_TERM: "SET_SEARCH_TERM",
  SET_INITIAL_STATE: "SET_INITIAL_STATE",
  TYPEAHEAD_DESTROY: "TYPEAHEAD_DESTROY",
  TYPEAHEAD_TOGGLE: "TYPEAHEAD_TOGGLE",
}

export default typeAheadConstants
